import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_FlBpsAnnual = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_FlBpsAnnual' className='file-pdf-document'>
            <div className='file-template'>
            <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Last Bio Psychosocial Date:</span>
                            <input type='date' id='txt_1' name='txt_1' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Annual Bio Physchosocial Date:</span>
                            <input type='date' id='txt_2' name='txt_2' className='add only' />
                        </td>
                    </tr>
                </table>
                <h2>Section A</h2>
                <p className='w-750'>
                    <span className='eleHeader'>1. CURRENT PROBLEMS AND PREVIOUS EVALUATIONS/MENTAL HEALTH TREATMENT</span>
                    <textarea id='txt_3' name='txt_3' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. CURRENT ALCOHOL/DRUG/TOBACCO USAGE AND HISTORY</span>
                    <textarea id='txt_4' name='txt_4' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. GENDER EXPRESSION AND SEXUAL ORIENTATION</span>
                    <textarea id='txt_5' name='txt_5' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. MEDICAL HISTORY</span>
                    <textarea id='txt_5_1' name='txt_5_1' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5. FAMILY DYNAMICS (HISTORY AND CURRENT FUNCTIONING)</span>
                    <textarea id='txt_5_2' name='txt_5_2' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6. PHYSICAL/SEXUAL ABUSE HISTORY</span>
                    Has the client witnessed a traumatic event? If yes, please specify:<br />
                    <textarea id='txt_6' name='txt_6' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    Has the client experienced a traumatic event? If yes, please specify:<br />
                    <textarea id='txt_7' name='txt_7' className='add only'></textarea>
                </p>
                <h4>7.School/Employment/Military Information</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational - Highest level Achieved</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_1' name='rb_7' className='add only' value='1' /> Grade School (K-5)
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_2' name='rb_7' className='add only' value='2' /> Middle School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_3' name='rb_7' className='add only' value='3' /> High School, no diploma
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_4' name='rb_7' className='add only' value='4' /> Diploma/ GED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_5' name='rb_7' className='add only' value='5' /> Some College or Technical School
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_6' name='rb_7' className='add only' value='6' /> {`2-year college, Associate’s Degree`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_7' name='rb_7' className='add only' value='7' /> {`4-year college, Bachelor’s Degree`}
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_7_8' name='rb_7' className='add only' value='8' /> Professional Degree or More
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational- current enrollment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_1' name='rb_8' className='add only' value='1' /> None
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_2' name='rb_8' className='add only' value='2' /> Alternative Learning Program
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_3' name='rb_8' className='add only' value='3' /> Academic School (K-12)
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_4' name='rb_8' className='add only' value='4' /> Vocational or Technical School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_5' name='rb_8' className='add only' value='5' /> College
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_8_6' name='rb_8' className='add only' value='6' /> GED Program Literacy Level: </td></tr>

                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txt_9' name='txt_9' className='add only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Need for Assistive Techology:</span>
                    <textarea id='txt_10' name='txt_10' className='add only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Occupational</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_11_1' name='rb_11' className='add only' value='1' /> Full-time work (35 hours/week)
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_11_2' name='rb_11' className='add only' value='2' /> Part-time work (less than 35
                            hours/week)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_11_3' name='rb_11' className='add only' value='3' /> Unemployed and seeking employment
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_11_4' name='rb_11' className='add only' value='4' /> Unemployed- not seeking employment
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Not labor force and not seeking due to:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_1' name='rb_12' className='add only' value='1' /> Homemaker
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_2' name='rb_12' className='add only' value='w-750' /> Student
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_3' name='rb_12' className='add only' value='3' /> Retired
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_4' name='rb_12' className='add only' value='4' /> Receiving Disability
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_5' name='rb_12' className='add only' value='5' /> Incarcerated
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_6' name='rb_12' className='add only' value='6' /> Institutionalized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_7' name='rb_12' className='add only' value='7' /> Court ordered community service
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_8' name='rb_12' className='add only' value='8' /> Structured day activity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_9' name='rb_12' className='add only' value='9' /> Unpaid vocational rehabilitation
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_12_10' name='rb_12' className='add only' value='10' /> Volunteer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rb_12_11' name='rb_12' className='add only' value='11' /> None
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Employer</span>
                            <input type='text' id='txt_13' name='txt_13' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current School</span>
                            <input type='text' id='txt_14' name='txt_14' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Position:</span>
                            <input type='text' id='txt_15' name='txt_15' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Disposition towards current work/school:</span>
                            <input type='text' id='txt_16' name='txt_16' className='add only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Identified stressors in the workplace/academic setting:</span>
                    <textarea id='txt_17' name='txt_17' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txt_18' name='txt_18' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 8. SOCIAL/ LEGAL/ PSYCHOSEXUAL FUNCTIONING (HOME, FAMILY, PEERS COMMUNITY)</span>
                    <textarea id='txt_19' name='txt_19' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 9. CULTURAL AND SPIRITUAL INFORMATION</span>
                    <textarea id='txt_20' name='txt_20' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>10. MEDICATION INFORMATION</span>Is the client currently prescribed medication?
                    <input type='radio' id='rb_21_Y' name='rb_21' className='add only' value='1' />   Yes &nbsp;
                    <input type='radio' id='rb_21_N' name='rb_21' className='add only' value='0' />  No<br />
                    If yes, please complete the chart below:
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Medications</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medication:</span>
                            <input type='text' id='txt_22' name='txt_22' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dosage:</span>
                            <input type='text' id='txt_23' name='txt_23' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribed by:</span>
                            <input type='text' id='txt_24' name='txt_24' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant:</span>
                            <input type='radio' id='rb_22_1' name='rb_22' className='add only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_22_2' name='rb_22' className='add only' value='w-750' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy:</span>
                            <input type='text' id='txt_25' name='txt_25' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects:</span>
                            <input type='text' id='txt_26' name='txt_26' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen:</span>
                            <input type='text' id='txt_25_1' name='txt_25_1' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med:</span>
                            <input type='text' id='txt_26_1' name='txt_26_1' className='add only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medication:</span>
                            <input type='text' id='txt_27' name='txt_27' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dosage:</span>
                            <input type='text' id='txt_28' name='txt_28' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribed by:</span>
                            <input type='text' id='txt_29' name='txt_29' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant:</span>
                            <input type='radio' id='rb_30_1' name='rb_30' className='add only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_30_2' name='rb_30' className='add only' value='w-750' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy:</span>
                            <input type='text' id='txt_31' name='txt_31' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects:</span>
                            <input type='text' id='txt_32' name='txt_32' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen:</span>
                            <input type='text' id='txt_31_1' name='txt_31_1' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med:</span>
                            <input type='text' id='txt_32_1' name='txt_32_1' className='add only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medication:</span>
                            <input type='text' id='txt_37' name='txt_37' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dosage:</span>
                            <input type='text' id='txt_38' name='txt_38' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribed by:</span>
                            <input type='text' id='txt_39' name='txt_39' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant:</span>
                            <input type='radio' id='rb_40_1' name='rb_40' className='add only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_40_2' name='rb_40' className='add only' value='w-750' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy:</span>
                            <input type='text' id='txt_41' name='txt_41' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects:</span>
                            <input type='text' id='txt_42' name='txt_42' className='add only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen:</span>
                            <input type='text' id='txt_41_1' name='txt_41_1' className='add only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med:</span>
                            <input type='text' id='txt_42_1' name='txt_42_1' className='add only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Regimen</span>
                    <textarea id='txt_33' name='txt_33' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <textarea id='txt_34' name='txt_34' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Number of Months on Medication</span>
                    <textarea id='txt_35' name='txt_35' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <textarea id='txt_36' name='txt_36' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 11. SUICIDAL HISTORY AND INFORMATION (BAKER ACTS-HOSPITALIZATIONS</span>
                    <textarea id='txt_43' name='txt_43' className='add only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> 12. SIGNS AND SYMPTOMS THAT SUPPORT DSM DIAGNOSIS (HISTORY OR OBSERVATION)</span>
                    <textarea id='txt_44' name='txt_44' className='add only'></textarea>
                </p>
                <h2>Section B</h2>
                <p className='w-750'>Please see diagnosis information in the CLIENT INFO section at the top of this document.</p>

                <h2>Section C</h2>
                <p className='w-750'>
                    <span className='eleHeader'>UPDATED TREATMENT RECOMMENDATIONS</span>
                    <textarea id='txt_45' name='txt_45' className='add only'></textarea>
                </p>
                <h3>Treatment Recommendations</h3>
                <p className='w-750'>Based on this Assessment/Evaluatiopn Interview, this Person Served:</p>
                <p className='w-750'>
                    <input type='radio' id='rb_47_1' name='rb_47' className='add only' value='1' /> DOES NOT MEET DIAGNOSTIC CRITERIA and is not elgible for Community
                    Mental Health Services, Therefore this Person Served will be:
                </p>
                <p className='w-750'>
                    <input type='radio' id='rb_48_1' name='rb_48' className='add only' value='1' /> Discharged<br />
                    <input type='radio' id='rb_48_2' name='rb_48' className='add only' value='w-750' /> Transferred to another program-Specify:
                    <input type='text' id='txt_49' name='txt_49' className='add only' /><br />
                    <input type='radio' id='rb_48_3' name='rb_48' className='add only' value='3' /> Other/Referrals:
                    <input type='text' id='txt_50' name='txt_50' className='add only' />
                </p>
                <p className='w-750'>
                    <input type='radio' id='rb_49_1' name='rb_49' className='add only' value='1' /> Meets Diagnostic Criteria for (limited
                    to ICD-9 diagnoses of 290 through 298.9,300 through 301.9, 302.7, 303 though 312.4 and 312.81 through
                    314.9, 315.3, 315.31, 315.5, 315.8 and 315.9)
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_50' name='cb_50' className='add only' value='1' /> Brief Behavior Health Exam
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_51' name='cb_51' className='add only' value='1' /> Individual/Family Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_52' name='cb_52' className='add only' value='1' /> Psychiatric Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_53' name='cb_53' className='add only' value='1' /> Group Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_54' name='cb_54' className='add only' value='1' /> Medication Management
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_55' name='cb_55' className='add only' value='1' /> Community Support Services (PSR)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_56' name='cb_56' className='add only' value='1' /> An In-Depth Assessment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_57' name='cb_57' className='add only' value='1' /> TBOS-Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_58' name='cb_58' className='add only' value='1' /> TBOS- Support Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_59' name='cb_59' className='add only' value='1' /> TBOS- Behavior Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cb_60' name='cb_60' className='add only' value='1' /> Other </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txt_61' name='txt_61' className='add only' /></td>
                    </tr>


                </table>


                
            </div>
        </form>

    )
}











